/**
 * A <video> that is never in the document, for a stream the stage does
 * not show. The presenter's own share is the case: their stage shows a
 * card where everyone else sees their screen (sharing a whole screen
 * would otherwise show the meeting showing the share, down the hall of
 * mirrors), so there is no element for the recorder to paint from. A
 * media element plays detached, and drawImage reads it all the same.
 */
export interface OffscreenVideo {
  readonly element: HTMLVideoElement
  /** Play this stream; the same stream again is a no-op. */
  bind(stream: MediaStream | null): void
  /** Let go of the stream — the decoder with it. */
  stop(): void
}

export function createOffscreenVideo(): OffscreenVideo {
  const element = document.createElement('video')
  element.muted = true
  element.playsInline = true
  element.autoplay = true
  return {
    element,
    bind(stream) {
      if (element.srcObject === stream) return
      element.srcObject = stream
      if (stream) void element.play().catch(() => undefined)
    },
    stop() {
      element.srcObject = null
    },
  }
}
